<template>
  <v-select
    id="consultant-select"
    v-model="filter.usuarioId"
    item-text="nome"
    item-name="usuarioId"
    item-value="usuarioId"
    :items="users"
    :label="
      !this.isAT || this.$store.state.uf === 'MA'
        ? this.consultorValue || 'Responsável'
        : this.isAT
        ? 'ATS'
        : 'Consultor'
    "
    :placeholder="consultorLabel"
    :multiple="isMultiple"
    clearable
  >
    <template slot="no-data"> Nenhum usuário retornado </template>
  </v-select>
</template>

<script>
import { userAPI } from "./UserAPI";
import { mapGetters } from "vuex";

export default {
  name: "AppConsultantCombobox",
  props: ["filter", "consultorValue", "isMultiple"],
  mounted() {
    this.loadConsultant();
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  methods: {
    loadConsultant() {
      userAPI
        .listConsultant()
        .then((resp) => {
          this.users = resp.data.filter(
            (item) => item.habilitado && item.nome != "Administrador"
          );
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter usuários");
        });
    },
  },
  data() {
    return {
      users: [],
      consultorLabel: "Consultor",
    };
  },
};
</script>
